import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './BottomNav.css';

const BottomNav = () => {
    const location = useLocation();

    // Hide bottom nav on specific routes if needed, e.g., if a modal is full screen
    // if (location.pathname.startsWith('/some-route')) return null;

    return (
        <div className="bottom-nav">
            <NavLink to="/" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                <div className="icon-container">
                    <i className="bi bi-house-door-fill"></i>
                </div>
                <span>Home</span>
            </NavLink>
            <NavLink to="/jobs" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                <div className="icon-container">
                    <i className="bi bi-briefcase-fill"></i>
                </div>
                <span>Jobs</span>
            </NavLink>
            <NavLink to="/shop" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                <div className="icon-container">
                    <i className="bi bi-cart-fill"></i>
                </div>
                <span>Shop</span>
            </NavLink>
            <NavLink to="/physio-help" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}> 
                <div className="icon-container"> 
                    <i className="bi bi-question-circle"></i> 
                </div> 
                <span>Physio Help</span> 
            </NavLink>
        </div>
    );
};

export default BottomNav;
